import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-bb-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-115">
      <div className="max-w-3xl mx-auto text-center" data-id="element-116">
        <div className="bg-bb-orange/10 text-bb-orange-dark font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-117">
          Your Investment Is 100% Protected
        </div>
        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-8 tracking-tight" data-id="element-118">
          Total <span className="text-bb-orange" data-id="element-119">30-Day</span> Satisfaction
          Guarantee
        </h2>

        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-lg border border-bb-line relative" data-id="element-120">
          <div className="bg-bb-orange w-20 h-20 rounded-full flex items-center justify-center shadow-xl mx-auto mb-6 ring-4 ring-bb-orange/20" data-id="element-121">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-122" />
          </div>

          <h3 className="font-display font-bold uppercase text-2xl text-bb-charcoal mb-4 tracking-wide" data-id="element-123">
            Your money is 100% protected
          </h3>
          <p className="text-bb-slate text-base sm:text-lg leading-relaxed" data-id="element-124">
            You have 30 full days to explore the 6 volumes, run the drills in
            the gym, and evaluate the results. If you aren't fully satisfied,
            we'll provide a complete refund.{' '}
            <span className="font-bold text-bb-charcoal" data-id="element-125">
              Zero risk for you. Total commitment from us.
            </span>
          </p>
        </div>
      </div>
    </section>;
}